import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { USERS_QUERY } from '../graphql/queries'
import { FETCH_USERS } from '../redux/action-types'
import { cleanupFetchUsers } from '../redux/actions'

const useUsersQuery = () => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchUsers)
  const { isLoading, error, data, latestEvent } = useSelector(
    store => store.users.users,
  )

  const refetch = useCallback(
    () =>
      apolloService.query({
        query: USERS_QUERY,
        variables: {},
        dispatch,
        action: FETCH_USERS,
      }),
    [dispatch],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, data, latestEvent }
}

export default useUsersQuery
